export default __webpack_public_path__ + "static/media/301.7554d0a3.png";